import { LoginResultPage } from './LoginResultPage';

export const authRouter = {
  '/login/result': LoginResultPage,
};
